import { User } from 'oidc-client-ts'

/**
 * SessionStorage snapshot of the OIDC user before token-exchange impersonation.
 * Restored on "end impersonation" so the admin returns without a full Keycloak redirect.
 */
const STORAGE_KEY = 'communo_pre_impersonation_oidc'

export function savePreImpersonationOidcSnapshot(user: User): void {
  try {
    if (!user?.access_token) {
      return
    }
    sessionStorage.setItem(STORAGE_KEY, user.toStorageString())
  } catch {
    //
  }
}

export function readPreImpersonationOidcSnapshot(): User | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return null
    }
    return User.fromStorageString(raw)
  } catch {
    return null
  }
}

export function clearPreImpersonationOidcSnapshot(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    //
  }
}
